import React, { Fragment } from 'react';
import Table from 'react-bootstrap/Table';
import flag1 from '../../content/Flag96_1.png';
import flag2 from '../../content/Flag96_2.png';
import noFlag from '../../content/NoCCAPP64.png';

import './CadeAnalyze.css';

const CadeAnalyzeRecommendations = (props) => {
    if (props.concerns.length == 0) {
        return null;
    }

    const displayFlags = props.displayFlags;
    let flagIcon = null;
    // Recommendations
    const recList = props.concerns.map((concern) => {
        switch (concern.flagPriority) {
            case 1:
                flagIcon = flag1;
                break;
            case 2:
                flagIcon = flag2;
                break;
            default:
                flagIcon = noFlag;
                break;
        }
        return (
            <tr>
                {displayFlags &&
                    <td><img className='cadeAnalyze_concernFlag' src={flagIcon} alt="Concern Flag" /></td>
                }
                <td width="30%">
                    {concern.assessmentArea}
                </td>
                <td width="70%" dangerouslySetInnerHTML={{
                    __html: concern.recommendation
                }} >

                </td>
            </tr >
        );
    });

    return (
        <Fragment>
            <h4 style={{ marginTop: 40 }}>{props.heading}</h4>

            <Table striped bordered responsive>
                <thead>
                    <tr>
                        {displayFlags &&
                            <th></th>
                        }
                        <th>Assessment Area</th>
                        <th>Recommendation</th>
                    </tr>
                </thead>
                <tbody>
                    {recList}
                </tbody>
            </Table>
        </Fragment>
    );
}

export default CadeAnalyzeRecommendations;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeAnalyzeRecommendations.js